import React from 'react';
import { useIntl, defineMessages } from 'react-intl';

import { Icon } from '@redturtle/iovisit-theme/components';
import {
  InfoBox,
  ViewBlocks,
  Booking,
  hasBooking,
  DownloadButton,
  hasDownload,
  RelatedItems,
} from '@redturtle/iovisit-theme/components/Views';

import DayCollapsed from '@redturtle/iovisit-theme/components/Views/Itinerary/DayCollapsed';

const messages = defineMessages({
  transport_methods: {
    id: 'itinerary_transport_methods',
    defaultMessage: 'Trasporti',
  },
  brochure: {
    id: 'itinerary_brochure',
    defaultMessage: 'Scarica la brochure',
  },
  possible_destinations: {
    id: 'itinerary_possible_destinations',
    defaultMessage: 'Continua ad esplorare',
  },
});

const ItineraryView = ({ content, location }) => {
  const intl = useIntl();
  const days = content.items?.filter((i) => i['@type'] === 'ItineraryDay');

  return (
    <div id="page-itinerary" className="ui container">
      {/* INFO BOX */}
      {(content.transport_methods?.length > 0 ||
        hasBooking(content) ||
        hasDownload(content.brochure) ||
        content.brochure?.download) && (
        <InfoBox>
          {content.transport_methods && (
            <>
              <h3>{intl.formatMessage(messages.transport_methods)}</h3>
              <div className="icons-list">
                {content.transport_methods.map((method) => (
                  <span title={method.title} key={method.token}>
                    <Icon icon={method.token} className="icon" />
                  </span>
                ))}
              </div>
            </>
          )}

          <Booking content={content} />

          <DownloadButton
            file={content.brochure}
            title={intl.formatMessage(messages.brochure)}
          />
        </InfoBox>
      )}

      <ViewBlocks content={content} location={location} />

      {/* GIORNATE ITINERARIO */}

      {days.length > 0 &&
        (days.length > 1 ? (
          days.map((day, index) => (
            <DayCollapsed day={day} key={`day${index}`} />
          ))
        ) : (
          <DayCollapsed day={days[0]} key={days[0]['@id']} />
        ))}

      <RelatedItems
        title={intl.formatMessage(messages.possible_destinations)}
        items={content.relatedItems}
        background={true}
        bg_color="tertiary"
      />
    </div>
  );
};

export default ItineraryView;
